import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'reducers';
import { UserBillingPlan, UserRole } from '../types/user';
import { getIsAvomaDemoAccount, isSSOAccount } from 'helpers/user';
import env from 'helpers/env';

const useCurrentUser = () => {
  const user = useSelector((state: RootState) => state.user);

  return useMemo(() => {

    const authProvider = user?.authProvider;
    const isAvomaDemoAccount = getIsAvomaDemoAccount() || env.name !== 'prod';

    const isTrial = user?.userLicense?.subscription.inTrial;
    const isBasic = user?.userLicense?.subscription.planId === UserBillingPlan.BasicMonthly;
    const isPaid = !isTrial && !isBasic;

    return {
      plan: {
        isTrial,
        isBasic,
        isPaid
      },
      user,
      isUserAdmin: user?.orgRole?.name === UserRole.admin,
      isAvomaDemoAccount,
      isSSOAccount: isSSOAccount(authProvider)
    };
  }, [user]);

};

export default useCurrentUser;